import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

import { CommonService } from '../../common/services/common.service';
import { AutocompleteSearchService } from './autocomplete-search.service';
import {FormControl} from '@angular/forms';

import {startWith} from 'rxjs/operators/startWith';
import {map} from 'rxjs/operators/map';

@Component({
  selector: 'app-autocomplete-search',
  templateUrl: './autocomplete-search.component.html',
  styleUrls: ['./autocomplete-search.component.css']
})
export class AutocompleteSearchComponent implements OnInit {
  myControl = new FormControl();
  options = [];
@Input() idName='';
@Input() listIdName='';
  @Input() placeHolder = '';
  @Output() onResultSelected: EventEmitter<any> = new EventEmitter<any>();
  @Input() searchKey = '';
  @Input() autoCompleteRequired:boolean=true;
  isActive = false;
  showSpinner = false;
  listIndex = 0;
  searchResults: any = [];
  airportSearchObj = { 'Language': '', 'ResultCount': 5, 'SearchKey': '' };

  constructor(private _commonService: CommonService, private _autocompleteSearchService: AutocompleteSearchService) { }

  ngOnInit() {
    this.airportSearchObj.Language = this._commonService.defaultLang;

    this.myControl.valueChanges.subscribe(value => {
      this.searchKey = value;
      this.onSearchKeyPress(value);
    });

    // this.myControl.valueChanges
    // .pipe(
    //   startWith(''),
    //   map(val => val.length >= 2 ? this.onSearchKeyPress(val): [])
    // );
  }

  onSearchKeyPress(key) {
    if (this.searchKey) {
      if(this.autoCompleteRequired){
        if (this.searchKey.length > 2) {
          //event.preventDefault();
          this.searchKey = key;
          this.airportSearchObj.SearchKey = this.searchKey;
          this.getSearchResults();
        } else { this.hideResults(); }
      }
     
    }
  }

  getSearchResults() {
    this.showSpinner = true;
  
    this._autocompleteSearchService.getAirportList(this.airportSearchObj).subscribe((data: any) => {
        if (data.status && data.message === 'success') {
        this.searchResults = data.data.Locations;
        this.showSpinner = false;
        this.isActive = true;
        setTimeout(() => {
          this.addHighlightClass();
        }, 100);
      }
    });
  }

  hideResults() {
    // this.searchResults = [];
    this.isActive = false;
    this.listIndex = 0;
  }

  /** Method to bind location/airport name to input field
   * @param Result - selected result object
   */
  emitSelectedResult(result) {
    this.searchKey = result.Name;
    this.onResultSelected.emit(result);
    this.hideResults();
  }

  addHighlightClass() {
    const el = document.getElementsByClassName('ac-result-item')[this.listIndex] as HTMLInputElement;
    if (el) { el.classList.add('highlight-item'); }
  }

  removeHighlightClass() {
    const el = document.getElementsByClassName('ac-result-item')[this.listIndex] as HTMLInputElement;
    if (el) { el.classList.remove('highlight-item'); }
  }

  onArrowKeyDown(event) {
    event.preventDefault();
    this.removeHighlightClass();
    this.listIndex === document.getElementsByClassName('ac-result-item').length - 1 ? this.listIndex = 0 : this.listIndex++;
    this.addHighlightClass();
  }

  onArrowKeyUp(event) {
    event.preventDefault();
    this.removeHighlightClass();
    this.listIndex === 0 ? this.listIndex = document.getElementsByClassName('ac-result-item').length - 1 : this.listIndex--;
    this.addHighlightClass();
  }

  onEnterKeyPress(event) {
    event.preventDefault();
    this.emitSelectedResult(this.searchResults[this.listIndex]);
  }

  onBacKeyPress() {
    this.airportSearchObj.SearchKey = this.searchKey;
    this.getSearchResults();
  }

  /**SetTimeOut is given to make a delay in hiding list, since the focusout event triggers before mouse click */
  onFocusOutEvent() {
    this.showSpinner = false;
    setTimeout(() => {
      this.hideResults();
    }, 500);
  }

  enableAuto(){
    this.autoCompleteRequired = true;
  }

  onInputFocus(event) {
    event.target.select();
    //if (this.searchKey) { this.searchKey = ''; this.onResultSelected.emit(null); }
  }
}
